import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, Instagram } from "lucide-react";
import { LOGO_URL, INSTAGRAM_URL } from "../../lib/api";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goSection = (id) => {
    setOpen(false);
    if (loc.pathname !== "/") {
      nav("/#" + id);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const links = [
    { label: "Home", id: "home" },
    { label: "Prijslijst", id: "prijslijst" },
    { label: "Locatie", id: "locatie" },
    { label: "Contact", id: "contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-md border-b border-brand-border shadow-sm" : "bg-transparent"
      }`}
      data-testid="public-navbar"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Nails Renss logo" className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover" />
          <span className="font-display text-xl md:text-2xl font-semibold tracking-tight text-brand-charcoal">
            Nails Renss
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => goSection(l.id)}
              className="text-sm font-medium text-brand-charcoal/80 hover:text-brand-pinkhover transition-colors"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="text-brand-charcoal/70 hover:text-brand-pinkhover transition-colors" aria-label="Instagram">
            <Instagram size={20} />
          </a>
          <Link
            to="/boeken"
            className="bg-brand-charcoal text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-brand-pinkhover transition-colors"
            data-testid="nav-book-button"
          >
            BOEK JE AFSPRAAK
          </Link>
        </nav>

        <button className="md:hidden text-brand-charcoal p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-b border-brand-border px-4 py-4 space-y-1 animate-fade-up">
          {links.map((l) => (
            <button key={l.id} onClick={() => goSection(l.id)} className="block w-full text-left py-3 px-2 text-base font-medium text-brand-charcoal border-b border-brand-border/60" data-testid={`nav-mobile-${l.id}`}>
              {l.label}
            </button>
          ))}
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 py-3 px-2 text-base font-medium text-brand-charcoal">
            <Instagram size={18} /> @nails.renss
          </a>
          <Link to="/boeken" onClick={() => setOpen(false)} className="block text-center bg-brand-charcoal text-white font-semibold py-3 rounded-full mt-2">
            BOEK JE AFSPRAAK
          </Link>
        </div>
      )}
    </header>
  );
}
